import CPPContactDetailsView from 'text!../views/cpp-contact-details.html';
import CPPPreQualQuestionsView from 'text!../views/cpp-prequal-questions.html';
import CPPGeneralCoveragesView from 'text!../views/cpp-general-coverages.html';
import CPPAdditionalCoveragesView from 'text!../views/cpp-additional-coverages.html';
import CPPDiscountsView from 'text!../views/cpp-discounts.html';
import CPPLocationsAndBuildingsView from 'text!../views/cpp-locations-and-buildings.html';
import CPPPolicyInfoView from 'text!../views/cpp-policy-info.html';

import CPPContactDetailsCtrl from '../controllers/CPPContactDetailsCtrl';
import CPPPreQualQuestionsCtrl from '../controllers/CPPPrequalQuestionsCtrl';
import CPPGeneralCoveragesCtrl from '../controllers/CPPGeneralCoveragesCtrl';
import CPPAdditionalCoveragesCtrl from '../controllers/CPPAdditionalCoveragesCtrl';
import CPPDiscountsCtrl from '../controllers/CPPDiscountsCtrl';
import CPPPolicyInfoCtrl from '../controllers/CPPPolicyInfoCtrl';

export default (function () {
    var wizardParentState = 'baseTransactionWizard';

    return {
        cppContactDetails: {
            parent: wizardParentState,
            template: CPPContactDetailsView,
            controller: CPPContactDetailsCtrl
        },
        cppPrequalQuestions: {
            parent: wizardParentState,
            template: CPPPreQualQuestionsView,
            controller: CPPPreQualQuestionsCtrl
        },
        cppGeneralCoverages: {
            parent: wizardParentState,
            template: CPPGeneralCoveragesView,
            controller: CPPGeneralCoveragesCtrl
        },
        cppAdditionalCoverages: {
            parent: wizardParentState,
            template: CPPAdditionalCoveragesView,
            controller: CPPAdditionalCoveragesCtrl
        },
        cppDiscounts: {
            parent: wizardParentState,
            template: CPPDiscountsView,
            controller: CPPDiscountsCtrl
        },
        cppLocationsAndBuildings: {
            parent: wizardParentState,
            template: CPPLocationsAndBuildingsView,
            params: {
                // Building and location ids are passed to focus the location/building that was just edited
                buildingId: null,
                locationId: null
            }
        },
        cppPolicyInfo: {
            parent: wizardParentState,
            controller: CPPPolicyInfoCtrl,
            template: CPPPolicyInfoView
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/ama/cpp/config/RouteConfig.js
// module id = 821
// module chunks = 0